import React from 'react';
import classNames from 'classnames/bind';

import styles from './Account.module.scss';

const cx = classNames.bind(styles);

const selectStyle = {
    width: '100%',
    padding: '0.65rem 0.8rem',
    borderRadius: '14px',
    border: '1px solid rgba(203, 213, 225, 0.9)',
    background: 'rgba(248, 250, 252, 0.9)',
    fontSize: '0.9rem',
    fontFamily: 'inherit',
    color: '#0f172a',
};

function CreateAccountModal({
    isOpen,
    isSubmitting,
    formValues,
    formErrors,
    submitError,
    onClose,
    onChange,
    onSubmit,
    departmentOptions = [],
    positionOptions = [],
}) {
    if (!isOpen) return null;

    return (
        <div className={cx('modal-backdrop')} role="presentation" onMouseDown={onClose}>
            <div
                className={cx('modal')}
                role="dialog"
                aria-modal="true"
                aria-labelledby="create-account-title"
                onMouseDown={(event) => event.stopPropagation()}
            >
                <header className={cx('modal__header')}>
                    <div>
                        <h2 id="create-account-title">Tạo tài khoản mới</h2>
                        <p>Nhập thông tin cơ bản để tạo tài khoản cho nhân sự.</p>
                    </div>
                    <button type="button" className={cx('modal__close')} onClick={onClose} disabled={isSubmitting}>
                        ×
                    </button>
                </header>
                <form className={cx('modal__body')} onSubmit={onSubmit}>
                    <div className={cx('form-grid')}>
                        <label className={cx('form-field')}>
                            <span>Tên đăng nhập</span>
                            <input
                                name="username"
                                type="text"
                                value={formValues.username}
                                onChange={onChange}
                                placeholder="Nhập tên đăng nhập"
                                disabled={isSubmitting}
                            />
                            {formErrors.username && <small className={cx('field-error')}>{formErrors.username}</small>}
                        </label>
                        <label className={cx('form-field')}>
                            <span>Họ và tên</span>
                            <input
                                name="fullname"
                                type="text"
                                value={formValues.fullname}
                                onChange={onChange}
                                placeholder="Nhập họ và tên"
                                disabled={isSubmitting}
                            />
                            {formErrors.fullname && <small className={cx('field-error')}>{formErrors.fullname}</small>}
                        </label>
                        <label className={cx('form-field')}>
                            <span>Email</span>
                            <input
                                name="email"
                                type="email"
                                value={formValues.email}
                                onChange={onChange}
                                placeholder="Email (có thể bỏ trống)"
                                disabled={isSubmitting}
                            />
                        </label>
                        <label className={cx('form-field')}>
                            <span>Mật khẩu</span>
                            <input
                                name="password"
                                type="password"
                                value={formValues.password}
                                onChange={onChange}
                                placeholder="Tối thiểu 8 ký tự"
                                disabled={isSubmitting}
                            />
                            {formErrors.password && <small className={cx('field-error')}>{formErrors.password}</small>}
                        </label>
                        <label className={cx('form-field')}>
                            <span>Phòng ban</span>
                            <select
                                name="department"
                                value={formValues.department}
                                onChange={onChange}
                                style={selectStyle}
                                disabled={isSubmitting}
                            >
                                <option value="">Chọn phòng ban</option>
                                {departmentOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            {formErrors.department && <small className={cx('field-error')}>{formErrors.department}</small>}
                        </label>
                        <label className={cx('form-field')}>
                            <span>Chức vụ</span>
                            <select
                                name="position"
                                value={formValues.position}
                                onChange={onChange}
                                style={selectStyle}
                                disabled={isSubmitting}
                            >
                                <option value="">Chọn chức vụ</option>
                                {positionOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            {formErrors.position && <small className={cx('field-error')}>{formErrors.position}</small>}
                        </label>
                    </div>
                    {submitError && <p className={cx('submit-error')}>{submitError}</p>}
                    <footer className={cx('modal__footer')}>
                        <button type="button" className={cx('secondary-button')} onClick={onClose} disabled={isSubmitting}>
                            Hủy
                        </button>
                        <button type="submit" className={cx('primary-button', 'primary-button--solid')} disabled={isSubmitting}>
                            {isSubmitting ? 'Đang tạo...' : 'Tạo tài khoản'}
                        </button>
                    </footer>
                </form>
            </div>
        </div>
    );
}

export default CreateAccountModal;
